/* 
Main is used for loading different modules, navbar and sidebar
*/
import React from 'react';
import { BrowserRouter as Router, Route, Switch, Link } from "react-router-dom";

//Components
import Navbar from 'common/Navbar'
// import Sidebar from 'common/sidebar'
import SnackBar from 'common/Snackbar'

import About from './modules/about'
import Landing from './modules/landing'
import Service from './modules/service'
import Profile from './modules/profile'
import ViewProfile from './modules/profile/viewProfile'
import BuildResume from './modules/resume'
import ShortlistAspirant from './modules/shortlist'
import PostJobs from './modules/postJobs'

import { SelectDD , ExternalDD } from './common/dropdowns'

const MainContainer = (props) => {
    var { store = {} } = props
    return (
      <div style={{overflow:'hidden'}}>
        <Navbar store={store} />
        <div className="main-container">
          {/*<Sidebar store={store} />*/}
          <div className="landing-content">
          <div className="main-body">          
            <Switch>
              <Route path="/service">
                <Service store={store} />
              </Route>
              <Route path="/about">
                <About store={store} />
              </Route>
              <Route path="/profile">
                <Profile store={store} />
              </Route>
              <Route path="/viewprofile">
                <ViewProfile store={store} />
              </Route>
              <Route path="/resume">
                <BuildResume store={store} />
              </Route>
              <Route exact path="/">
                <Landing store={store} />
              </Route>
              <Route path="/shortlist">
                <ShortlistAspirant store={store} />
              </Route>
              <Route path="/postJobs">
                <PostJobs store={store} />
              </Route>
            </Switch>            
            </div>
          </div>
        </div>
        <SnackBar />
      </div>
    );
}

export default MainContainer
